/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Remove_MemberInputs */

const en_us2_clubs_remove_member = /** @type {(inputs: Clubs_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove from the club`)
};

const pt_br2_clubs_remove_member = /** @type {(inputs: Clubs_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover do clube`)
};

const es_419_clubs_remove_member = /** @type {(inputs: Clubs_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quitar del club`)
};

const pt_pt2_clubs_remove_member = /** @type {(inputs: Clubs_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover do clube`)
};

const fr_fr2_clubs_remove_member = /** @type {(inputs: Clubs_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirer du club`)
};

const de_de2_clubs_remove_member = /** @type {(inputs: Clubs_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus dem Club entfernen`)
};

const it_it2_clubs_remove_member = /** @type {(inputs: Clubs_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi dal club`)
};

/**
* | output |
* | --- |
* | "Remove from the club" |
*
* @param {Clubs_Remove_MemberInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_remove_member = /** @type {((inputs?: Clubs_Remove_MemberInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Remove_MemberInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_remove_member(inputs)
	if (locale === "es-419") return es_419_clubs_remove_member(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_remove_member(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_remove_member(inputs)
	if (locale === "de-DE") return de_de2_clubs_remove_member(inputs)
	if (locale === "it-IT") return it_it2_clubs_remove_member(inputs)
	return en_us2_clubs_remove_member(inputs)
});
export { clubs_remove_member as "clubs.remove_member" }